import type { IRubricAPI } from 'Src/typings/api';
export const getRubricItems = (rubric_list: IRubricAPI[], clickCounterName?: string) => {
    const rubricItems: Array<IRubricAPI & {
        clickCounterName?: string;
    }> = rubric_list.map((item) => {
        return {
            ...item,
            clickCounterName,
        };
    });
    return rubricItems;
};
